import { railsUrl, vizUrl, waitFor } from './customs_util'

export class CustomsPopupAuthorization {
  #interval
  #expiresAt

  get loginUri () { return railsUrl('/login', { redirect: vizUrl('/sessions/required') }) }

  async waitForSession () {
    const currentTime = new Date()

    this.#interval = 1
    this.#expiresAt = currentTime.setMinutes(currentTime.getMinutes() + 1)

    while (this.#keepPolling()) {
      const data = await this.#poll()

      if (data.authenticated && data.customs) {
        return true
      }

      await waitFor(this.#interval)
    }

    throw new Error('Request expired')
  }

  #keepPolling () {
    return new Date() < this.#expiresAt
  }

  async #poll () {
    const response = await fetch(railsUrl('/sessions/check'), { credentials: 'include' })
    return await response.json()
  }
}
